<mat-sidenav-container fullscreen>
  <mat-sidenav #sidenav mode="side" class="example-sidenav mat-drawer-opened" [opened]="true"
    (mouseover)="toggleSidenav(true)" (mouseleave)="toggleSidenav(false)"
    [ngClass]="{ 'mat-drawer-opened': !isHovered }">
    <mindbase-sidebar></mindbase-sidebar>
  </mat-sidenav>
  <div class="example-sidenav-content">
    <div class="top_header">
      <div class="top_header_ryt">
        <div class="filter_box">
          <button (click)="getReceivedNotifications()" mat-button class="btn_icon ntfy_box" [matMenuTriggerFor]="menu1">
            <mat-icon>notifications_active</mat-icon>
            @if (newNotificationsCount) {
            <p>
              {{ newNotificationsCount }}
            </p>
            }
          </button>
          <mat-menu #menu1="matMenu" xPosition="before" yPosition="below" class="noti_dropBox">
            <div class="d_flx">
              <h2>{{ 'Notifications' | translate }}</h2>
              <button class="see_link" routerLink="/received-notification">
                {{ 'seeAll' | translate }}
              </button>
            </div>
            <ul class="not_list">
              @if (receivedNotification && receivedNotification.length) {
              @for (item of receivedNotification; track $index) {
              <li class="ntf-list">
                <figure>
                  <img [src]="assets.adminIcon" alt="profile" />
                </figure>
                <div class="ntf_dt">
                  <h3 [innerHTML]="item.title">
                    <span class="ntf_tym">{{
                      item?.createdAt | date
                      }}</span>
                  </h3>
                  <p [innerHTML]="item.message"></p>
                </div>
              </li>
              }
              } @else {
              <mindbase-no-data-found></mindbase-no-data-found>
              }
            </ul>
          </mat-menu>
          <button (click)="logout()" mat-button class="btn_icon">
            <mat-icon class="c_danger">exit_to_app</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="main_wrapper">
      <router-outlet />
    </div>
    <mat-menu #menu="matMenu"> </mat-menu>
  </div>
</mat-sidenav-container>
